import {
  INCOME_AND_EXPENSES,
  YOUR_ADDRESS_DETAILS,
  YOUR_CONTACT_DETAILS,
  YOUR_EMPLOYMENT_DETAILS,
  YOUR_FINANCIAL_CIRCUMSTANCES,
  YOUR_MAIN_BANK_ACCOUNT,
  YOUR_PERSONAL_DETAILS,
  YOUR_LOAN_OPTIONS,
  DIP_YOUR_LOAN_OPTIONS,
  DIP_PERSONAL_DETAILS,
  DIP_ADDRESS_DETAILS,
  DIP_EMPLOYMENT_DETAILS,
  DIP_CONTACT_DETAILS,
  INTERNAL_DEBT_CONSOLIDATE,
  NTB_DIP_KEEPING_YOU_SAFE,
  USER_TIMED_OUT,
  POST_DIP_EDIT_ADDRESS_DETAILS,
  POST_DIP_EDIT_EMPLOYMENT_DETAILS,
  POST_DIP_EDIT_INCOME_DETAILS,
  POST_DIP_EDIT_PERSONAL_DETAILS,
  POST_DIP_EDIT_CONTACT_DETAILS,
  DIP_REVIEW_DETAILS
} from 'constants/paths';
import { PRE_ASSESSED_JOURNEY, EXISTING_JOURNEY, NTB_JOURNEY } from 'constants/general';
import { isBackButtonHidden } from 'utils/isBackButtonHidden';

const editModePaths = [
  INCOME_AND_EXPENSES,
  YOUR_EMPLOYMENT_DETAILS,
  YOUR_CONTACT_DETAILS,
  YOUR_ADDRESS_DETAILS,
  YOUR_PERSONAL_DETAILS,
  DIP_YOUR_LOAN_OPTIONS,
  DIP_PERSONAL_DETAILS,
  DIP_ADDRESS_DETAILS,
  DIP_EMPLOYMENT_DETAILS,
  DIP_CONTACT_DETAILS,
  INTERNAL_DEBT_CONSOLIDATE,
  YOUR_LOAN_OPTIONS
];
/** 
Hide back button when user login from the brochureware and it has following condition:-
1. Pre assessed journey and path is financial details
2. Existing journey :- 
    a. Secondary applicant and path is main bank account
    b. Path is Loan calculator 
*/
export function shouldHideBackButton(exitModalOpen, config, pathname, navigation) {
  const { journey, isSecondaryApplicant, origin, inEditMode, hasStartAgain, loanType } = config;

  if (
    exitModalOpen ||
    pathname === USER_TIMED_OUT ||
    (journey === PRE_ASSESSED_JOURNEY && !origin && pathname === YOUR_FINANCIAL_CIRCUMSTANCES) ||
    (journey === EXISTING_JOURNEY &&
      ((isSecondaryApplicant && pathname === YOUR_MAIN_BANK_ACCOUNT) ||
        (!origin && pathname === YOUR_LOAN_OPTIONS && !hasStartAgain))) ||
    pathname === DIP_REVIEW_DETAILS ||
    (journey === NTB_JOURNEY &&
      (pathname === NTB_DIP_KEEPING_YOU_SAFE ||
        pathname === POST_DIP_EDIT_ADDRESS_DETAILS ||
        pathname === POST_DIP_EDIT_EMPLOYMENT_DETAILS ||
        pathname === POST_DIP_EDIT_INCOME_DETAILS ||
        pathname === POST_DIP_EDIT_PERSONAL_DETAILS ||
        pathname === POST_DIP_EDIT_CONTACT_DETAILS))
  ) {
    return true;
  }
  return (
    isBackButtonHidden(pathname) ||
    ((inEditMode || navigation?.isEditFlow) && editModePaths.includes(pathname))
  );
}
